import { IPaginatedRequest, IPaginatedResponse, IResponse } from '@cbgms/api'
import { ExternalSystem, ExternalSystemListResponse, NewExternalSystem } from '@cbgms/api/modules/shops/external-systems'
import * as requests from '@cbgms/api/modules/shops/external-systems/requests'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import * as types from './types'

export const getExternalSystems = (companyUUID: string, shopId: string, params: IPaginatedRequest) =>
  AsyncAction<IPaginatedResponse<ExternalSystemListResponse>>({
    type: [types.GET_EXTERNAL_SYSTEMS, types.GET_EXTERNAL_SYSTEMS_SUCCESS, types.GET_EXTERNAL_SYSTEMS_FAILED],
    payload: {
      api: 'support',
      request: requests.getExternalSystems(companyUUID, shopId, params)
    }
  })

export const getExternalSystem = (companyUUID: string, shopId: string, externalSystemUUID: string) =>
  AsyncAction<IResponse<ExternalSystem>>({
    type: [types.GET_EXTERNAL_SYSTEM, types.GET_EXTERNAL_SYSTEM_SUCCESS, types.GET_EXTERNAL_SYSTEM_FAILED],
    payload: {
      api: 'support',
      request: requests.getExternalSystem(companyUUID, shopId, externalSystemUUID)
    }
  })

export const createExternalSystem = (companyUUID: string, shopId: string, data: NewExternalSystem) =>
  AsyncAction<IPaginatedResponse<ExternalSystemListResponse>>({
    type: [types.POST_EXTERNAL_SYSTEM, types.POST_EXTERNAL_SYSTEM_SUCCESS, types.POST_EXTERNAL_SYSTEM_FAILED],
    payload: {
      api: 'support',
      request: requests.createExternalSystem(companyUUID, shopId, data)
    }
  })

export const updateExternalSystem = (companyUUID: string, shopId: string, externalSystemUUID: string, data: NewExternalSystem) =>
  AsyncAction<IPaginatedResponse<ExternalSystemListResponse>>({
    type: [types.POST_EXTERNAL_SYSTEM, types.POST_EXTERNAL_SYSTEM_SUCCESS, types.POST_EXTERNAL_SYSTEM_FAILED],
    payload: {
      api: 'support',
      request: requests.updateExternalSystem(companyUUID, shopId, externalSystemUUID, data)
    }
  })

export const getExternalSystemValues = () =>
  AsyncAction<IResponse<string[]>>({
    type: [types.GET_ENUM_EXTERNAL_SYSTEMS, types.GET_ENUM_EXTERNAL_SYSTEMS_SUCCESS, types.GET_ENUM_EXTERNAL_SYSTEMS_FAILED],
    payload: {
      api: 'support',
      request: requests.getExternalSystemValues()
    }
  })

export const deleteExternalSystem = (companyUUID: string, shopId: string, externalSystemUUID: string, dryRun: boolean) =>
  AsyncAction<IPaginatedResponse<ExternalSystemListResponse>>({
    type: [types.DELETE_EXTERNAL_SYSTEM, types.DELETE_EXTERNAL_SYSTEM_SUCCESS, types.DELETE_EXTERNAL_SYSTEM_FAILED],
    payload: {
      api: 'support',
      request: requests.deleteExternalSystem(companyUUID, shopId, externalSystemUUID, dryRun)
    }
  })
